"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsBoolean = exports.isBoolean = void 0;
const isBoolean_1 = __importDefault(require("lodash/isBoolean"));
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const Exists_1 = require("./Exists");
async function isBoolean(value, args, constraints) {
    const validateExistsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: true,
    });
    if (validateExistsResults.pass === false || validateExistsResults.skipped) {
        return validateExistsResults;
    }
    if (!(0, isBoolean_1.default)(value)) {
        return { pass: false, message: `should be a boolean` };
    }
    return { pass: true };
}
exports.isBoolean = isBoolean;
/**
 * Validates that the value is a valid boolean
 * NOTE: Differs from the class-validator version by allowing additional constraints
 */
function IsBoolean(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsBoolean",
        defaultMessage: "should be a valid boolean",
        options,
        constraints,
        validateFn: isBoolean,
    });
}
exports.IsBoolean = IsBoolean;
//# sourceMappingURL=IsBoolean.js.map